import React from 'react';
import PropTypes from 'prop-types';
import { Icons } from '@techsoftware/happay-widgets';
import Animation from '../animation';

const ContainerIcons = props => (
  <div className="list-text ">
    <Animation
      play={props.toggle}
      type={props.name.icon}
      height={24}
      width={24}
      className="navbar-icon"
      autoPlay={props.toggle}
    />
    {/* <Icons active={props.toggle} size="large" type={props.name.icon} /> */}
    {/* {props.actionRequired && (
        <span
          className="pending-cue"
          style={{ marginTop: '-13px', marginLeft: '-8px' }}
        ></span>
      )} */}
  </div>
);

ContainerIcons.propTypes = {
  name: PropTypes.object,
  toggle: PropTypes.bool,
};

ContainerIcons.defaultProps = {
  name: {},
};

export default ContainerIcons;
